$(function () {
    if($('.address_picker').length){
        $(document).on('change', '#post_code', function(){
            $('.address_picker .geo_lat').val('');
            $('.address_picker .geo_long').val('');
        });


    const params = new URLSearchParams(window.location.search);

    if (params.has('post_code')) {
        $('#post_code').val(params.get('post_code')).trigger('change');
        autoFillAddress();
    }

        $('.geo-lat-long').on('click', function (e) {
            navigator.geolocation.getCurrentPosition(
                function (position) {
                    const lat = position.coords.latitude;
                    const lon = position.coords.longitude;
                    if (lat != null && lon != null) {
                        $('.address_picker .geo_lat').val(lat);
                        $('.address_picker .geo_long').val(lon);
                        autoFillAddress();
                        $('.address_picker .geo-lat-long').html('<i class="fas fa-check text-success"></i>');
                    } else {
                        $('.address_picker .geo-lat-long').html('<i class="fas fa-times text-danger"></i>');
                    }
                },
                function (error) {
                    // Handle errors
                    autoFillAddress();
                    switch (error.code) {
                        case error.PERMISSION_DENIED:
                            beautify.alert("Location access denied. Please allow location access and try again.");
                            break;
                        case error.POSITION_UNAVAILABLE:
                            beautify.alert("Location unavailable. Please check your device settings.");
                            break;
                        case error.TIMEOUT:
                            beautify.alert("Location request timed out. Try again.");
                            break;
                        default:
                            beautify.alert("Unknown error occurred.");
                            break;
                    }

                    $('.address_picker .geo-lat-long').html('<i class="fas fa-times text-danger"></i>');
                },
                {
                    enableHighAccuracy: true,
                    timeout: 10000,
                    maximumAge: 0
                }
            );
        });


        function autoFillAddress(){
            $.ajax({
                url: '/api/address',
                method: 'GET',
                data: $('.address_picker').serializeJSON(),
                success: function(data){
                    $('#address').val(data.address);
                    $('#post_code').val(data.post_code);
                    $('#city').val(data.city);
                    $('.geo_lat').val(data.latitude);
                    $('.geo_long').val(data.longitude);
                }
            })
        }
    }
});
